import React from 'react'
import { useTranslation } from 'react-i18next'
import { FormWarningAlert } from 'components/reusables/formWarningAlert'
import { InactiveCourseAlertWrapper } from './styled'

export const InactiveCourseReviewAlert: React.FC = () => {
  const { t } = useTranslation()

  return (
    <InactiveCourseAlertWrapper>
      <FormWarningAlert
        message={t('courses.inactive.reviewReadOnlyWarningBannerCompact')}
      />
    </InactiveCourseAlertWrapper>
  )
}
